/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AcceptPolicyRequest
 */
export interface AcceptPolicyRequest {
    /**
     * 
     * @type {string}
     * @memberof AcceptPolicyRequest
     */
    userEmail: string;
    /**
     * 
     * @type {string}
     * @memberof AcceptPolicyRequest
     */
    policyName: string;
    /**
     * 
     * @type {string}
     * @memberof AcceptPolicyRequest
     */
    policyDisplayText: string | null;
}

/**
 * Check if a given object implements the AcceptPolicyRequest interface.
 */
export function instanceOfAcceptPolicyRequest(value: object): value is AcceptPolicyRequest {
    if (!('userEmail' in value) || value['userEmail'] === undefined) return false;
    if (!('policyName' in value) || value['policyName'] === undefined) return false;
    if (!('policyDisplayText' in value) || value['policyDisplayText'] === undefined) return false;
    return true;
}

export function AcceptPolicyRequestFromJSON(json: any): AcceptPolicyRequest {
    return AcceptPolicyRequestFromJSONTyped(json, false);
}

export function AcceptPolicyRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AcceptPolicyRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'userEmail': json['userEmail'],
        'policyName': json['policyName'],
        'policyDisplayText': json['policyDisplayText'],
    };
}

export function AcceptPolicyRequestToJSON(json: any): AcceptPolicyRequest {
    return AcceptPolicyRequestToJSONTyped(json, false);
}

export function AcceptPolicyRequestToJSONTyped(value?: AcceptPolicyRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userEmail': value['userEmail'],
        'policyName': value['policyName'],
        'policyDisplayText': value['policyDisplayText'],
    };
}

